import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { io } from 'socket.io-client'

import App from './App.vue'
import router from './router'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(ElementPlus)

// 注册所有图标组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// Socket.IO 初始化
const socket = io(import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000', {
    transports: ['websocket']
})

// 将 socket 实例添加到全局属性
app.config.globalProperties.$socket = socket

app.mount('#app')